export interface AnnouncementConfig {
  enabled: boolean;
  activeKey: string;
  allowedRoutes: string[];
}

// The active announcement. Set enabled:false to stop showing it; change activeKey to
// re-run one for every user (nobody holds a seen-flag under a new key). Needs a deploy.
export const ANNOUNCEMENT_CONFIG: AnnouncementConfig = {
  enabled: true,
  activeKey: 'culture-launch',
  // Routes the popup may appear on, matched as a segment-aware prefix so a parent
  // covers its children. Empty means no restriction: every logged-in user, any page.
  // Note: ['/'] is NOT "everywhere" - it normalises to root and matches only '/'.
  allowedRoutes: ["/settings", "/culture/home"],
};
